/**
 * Announcement bar: slides within grid, autoplay + prev/next.
 * With 2+ slides, uses loop clones so forward autoplay always moves the same way (no backward wrap).
 */
(function () {
  function prefersReducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function initCarousel(root) {
    if (!root || root.getAttribute('data-announcement-initialized') === 'true') return;

    var viewport = root.querySelector('[data-announcement-viewport]');
    var track = root.querySelector('[data-announcement-track]');
    var originals = root.querySelectorAll('[data-announcement-slide]');
    var prevBtn = root.querySelector('[data-announcement-prev]');
    var nextBtn = root.querySelector('[data-announcement-next]');
    var n = originals.length;

    if (!viewport || !track || n === 0) return;

    root.setAttribute('data-announcement-initialized', 'true');

    var autoplay =
      root.getAttribute('data-autoplay') === 'true' && !prefersReducedMotion();
    var intervalMs = parseInt(root.getAttribute('data-interval') || '6000', 10) || 6000;
    var timer = null;
    var resizeTick = null;
    var isMoving = false;

    /** Logical position on extended track: [cloneLast, ...reals..., cloneFirst] */
    var pos = 0;
    var M = n;

    function setupInfiniteStrip() {
      if (n < 2) return;
      var first = originals[0];
      var last = originals[n - 1];
      var cloneFirst = first.cloneNode(true);
      var cloneLast = last.cloneNode(true);
      cloneFirst.setAttribute('data-announcement-slide-clone', 'first');
      cloneLast.setAttribute('data-announcement-slide-clone', 'last');
      cloneFirst.removeAttribute && cloneFirst.removeAttribute('id');
      cloneLast.removeAttribute && cloneLast.removeAttribute('id');
      track.insertBefore(cloneLast, first);
      track.appendChild(cloneFirst);
      M = n + 2;
      pos = 1;
    }

    setupInfiniteStrip();

    function applyTransform(animate) {
      var w = viewport.offsetWidth;
      var instant = animate === false || prefersReducedMotion();
      track.style.transition = instant ? 'none' : 'transform 0.45s ease';
      track.style.transform = 'translate3d(' + -pos * w + 'px, 0, 0)';
    }

    function snapIfNeededInstant() {
      if (n < 2) return;
      if (pos === M - 1) {
        pos = 1;
        applyTransform(false);
      } else if (pos === 0) {
        pos = n;
        applyTransform(false);
      }
    }

    function onTransitionEnd(e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      if (n < 2) {
        isMoving = false;
        return;
      }
      if (pos === M - 1 || pos === 0) {
        snapIfNeededInstant();
      }
      isMoving = false;
    }

    track.addEventListener('transitionend', onTransitionEnd);

    function moveForward() {
      if (n < 2) return;
      if (isMoving) return;
      isMoving = true;
      pos++;
      applyTransform(true);
      if (prefersReducedMotion()) {
        snapIfNeededInstant();
        isMoving = false;
      }
    }

    function moveBackward() {
      if (n < 2) return;
      if (isMoving) return;
      isMoving = true;
      pos--;
      applyTransform(true);
      if (prefersReducedMotion()) {
        snapIfNeededInstant();
        isMoving = false;
      }
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || n < 2) return;
      timer = setInterval(function () {
        moveForward();
      }, intervalMs);
    }

    function simpleGo(delta) {
      var idx = (((pos + delta) % n) + n) % n;
      pos = idx;
      applyTransform(true);
    }

    function onPrev() {
      stopAutoplay();
      if (n >= 2) moveBackward();
      else simpleGo(-1);
      startAutoplay();
    }

    function onNext() {
      stopAutoplay();
      if (n >= 2) moveForward();
      else simpleGo(1);
      startAutoplay();
    }

    if (prevBtn) prevBtn.addEventListener('click', onPrev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', startAutoplay);
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);

    function onResize() {
      if (resizeTick) cancelAnimationFrame(resizeTick);
      resizeTick = requestAnimationFrame(function () {
        resizeTick = null;
        applyTransform(false);
      });
    }

    var ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(onResize);
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', onResize);
    }

    function cleanup() {
      stopAutoplay();
      track.removeEventListener('transitionend', onTransitionEnd);
      if (ro) ro.disconnect();
      else window.removeEventListener('resize', onResize);
      root.removeAttribute('data-announcement-initialized');
    }

    root._announcementCleanup = cleanup;

    applyTransform(false);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-announcement-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-announcement-carousel]').forEach(function (root) {
      if (root._announcementCleanup) root._announcementCleanup();
    });
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-announcement-carousel]').forEach(initCarousel);
    });
  }
})();
